import type { AppStateController } from '../state/AppStateController';
import type { TournamentSaveData } from './types';
import { isTournamentValid } from './isTournamentValid';
import type { TournamentData } from '../platform/Platform';

export class TournamentDataSaver {
  constructor(private readonly state: AppStateController) {}

  public getTournaments(): TournamentSaveData[] {
    const { state } = this;

    const savedTournaments = state.getSavedTournaments();

    const activeTournaments = savedTournaments.filter((tournament) => isTournamentValid(tournament));

    if (activeTournaments.length !== savedTournaments.length) {
      state.setSavedTournaments(activeTournaments);
    }

    return activeTournaments;
  }

  public getTournament(tournamentId: string): TournamentSaveData | null {
    return this.getTournaments().find((savedData) => savedData.tournamentId === tournamentId) ?? null;
  }

  public addTournament(tournamentData: TournamentData): TournamentSaveData {
    const savedTournaments = this.getTournaments();
    const alreadySavedEntry = savedTournaments.find((saved) => saved.tournamentId === tournamentData.tournamentId);

    if (alreadySavedEntry) {
      return alreadySavedEntry;
    }

    const saveData: TournamentSaveData = {
      ...tournamentData,
      userScore: 0,
      cachedLeaderboard: [],
    };

    this.state.setSavedTournaments([...savedTournaments, saveData]);

    return saveData;
  }

  public saveData(tournamentSaveData: TournamentSaveData): void {
    const tournaments = this.getTournaments();
    const alreadyExists = tournaments.find((saved) => tournamentSaveData.tournamentId === saved.tournamentId);

    if (alreadyExists) {
      tournaments.splice(tournaments.indexOf(alreadyExists), 1, tournamentSaveData);
    } else {
      tournaments.push(tournamentSaveData);
    }

    this.state.setSavedTournaments(tournaments);
  }
}
